<template>
    <div class="run-select" v-click-outside="closeDropdown">
      <input
        type="text"
        class="form-control"
        v-model="searchQuery"
        placeholder="Search run or zone..."
        @focus="dropdownVisible = true"
      />
      <ul
        class="dropdown-list"
        v-if="dropdownVisible && filteredRuns.length"
      >
        <li
          v-for="(run, index) in filteredRuns"
          :key="run.runid"
          @click="selectRun(run)"
          :class="['dropdown-item', { even: index % 2 === 0 }]"
        >
          {{ run.runzone }} - {{ run.runname }}
        </li>
      </ul>
      <div class="selected-run" v-if="selectedRun">
        Selected: {{ selectedRun.runzone }} - {{ selectedRun.runname }}
      </div>
    </div>
  </template>  
  
  <script>
  import vClickOutside from 'v-click-outside';
  
  export default {
    name: "RunSelect",
    directives: {
      clickOutside: vClickOutside.directive
    },
    props: {
      runs: Array,
      value: Number,
    },
    data() {
      return {
        searchQuery: "",
        selectedRun: null,
        dropdownVisible: false
      };
    },
    computed: {
      filteredRuns() {
        if (!this.searchQuery) return this.runs;
        const query = this.searchQuery.toLowerCase();
        return this.runs.filter(
          (run) =>
            run.runname.toLowerCase().includes(query) ||
            run.runzone.toLowerCase().includes(query)
        );
      },
    },
    methods: {
      selectRun(run) {
        this.selectedRun = run;
        this.$emit("input", run.runid);
        this.searchQuery = "";
        this.dropdownVisible = false;
      },
      closeDropdown() {
        this.dropdownVisible = false;
        this.selectedRun = null;
        }
    },
    watch: {
      value(newVal) {
        if (newVal && !this.selectedRun) {
          this.selectedRun = this.runs.find((r) => r.runid === newVal);
        }
      },
    },
  };
  </script>
  <style scoped>
  .run-select {
    position: relative;
    max-width: 300px;
  }
  
  .dropdown-list {
    position: absolute;
    z-index: 9999;
    background: white;
    border: 1px solid #ccc;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
  
  .dropdown-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    transition: background 0.2s ease;
  }
  
  .dropdown-item:last-child {
    border-bottom: none;
  }
  
  .dropdown-item.even {
    background-color: #f9f9f9;
    }

    /* Ensure hover takes precedence */
.dropdown-item:hover,
.dropdown-item.even:hover {
    background-color: #e6f2ff !important;
    }
  
  .selected-run {
    margin-top: 8px;
    font-weight: bold;
    font-size: 0.95rem;
    color: #333;
  }
  </style>
  
  